document.addEventListener('reload', (e) => {
	window.location.reload();
});


